import { render, staticRenderFns } from "./TeamDescription.vue?vue&type=template&id=20aad9fa&scoped=true"
import script from "./TeamDescription.vue?vue&type=script&lang=js"
export * from "./TeamDescription.vue?vue&type=script&lang=js"
import style0 from "./TeamDescription.vue?vue&type=style&index=0&id=20aad9fa&prod&lang=scss&scoped=true"
import style1 from "./TeamDescription.vue?vue&type=style&index=1&id=20aad9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aad9fa",
  null
  
)

export default component.exports